module.exports = __webpack_public_path__ + "static/media/07.f76a4375.jpg";